export default "__VITE_ASSET__BimSU8NG__"